/**
 * Whether the PDP knows enough to offer a checkout: a signed-in buyer of a
 * digital listing must not be sold it again while auth or the ownership read
 * is still resolving.
 *
 * `currentUserId` and `purchasedAsset` are both tri-state, `undefined` meaning
 * "not known yet".
 */
export function isPurchaseOwnershipResolved<TAsset>({
  ownershipApplies,
  currentUserId,
  purchasedAsset,
}: {
  ownershipApplies: boolean;
  currentUserId: string | null | undefined;
  purchasedAsset: TAsset | null | undefined;
}): boolean {
  if (!ownershipApplies) return true;
  if (currentUserId === null) return true;
  if (currentUserId === undefined) return false;
  return purchasedAsset !== undefined;
}
